import api from '../api/axiosInstance';

export const getEmpleadosService = async () => {
    try {
        const response = await api.get('/propietario/listar-empleados');
        return response.data;
    } catch (error) {
        throw error.response?.data || { mensaje: 'Error desconocido al eliminar empleado' };
    }
};
